<template>
  <router-view :key="$route.fullPath"></router-view>
</template>

<script>
import moment from "moment-timezone";
export default {
  methods: {
    initializeLayout() {
      if (!this.$rtl.isRTL) {
        // Just make sure rtl css is off when we are not on rtl
        this.$rtl.disableRTL();
      }
    }
  },
  mounted() {
    this.initializeLayout();
    moment.tz.setDefault("America/Denver");
  }
};
</script>
